import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { IUbicacionCompletoDTO } from "../../../../../Interfaces/auxiliar/IUbicacion";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelActualizarUbi } from "./UsePanelActualizarUbi";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { TextField } from "@fluentui/react";

export interface IPanelActualizarUbi extends IOpenPanel{
  item:IUbicacionCompletoDTO
}
export const PanelActualizarUbi=(props:IPanelActualizarUbi)=>{
  const {request,setRequest,putEditarUbicacion,loading,reset,mensaje,status} = UsePanelActualizarUbi(props)
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Editar"
          texto2={"Salir"}
          onClick={putEditarUbicacion}
          onDismiss={() => {
            reset();
          }}
        />
      </>
    ),
    [request]
  );
    return(
        <PanelDrawer isOpen={props.isOpen} onRenderFooter={onRenderFooter} textHeader={"Actualizar Ubicación"} 
        onDismiss={reset} status={status} mensaje={mensaje} loading={loading}>
          <TextField
                type="text"
                label={`Nombre de  Ubicación`}
                placeholder="Ingrese Nombre de Ubicacion"
                autoComplete="off"
                value={request.nombre}
                onChange={(event, newValue) => {
                  if (newValue != null) {
                    setRequest({ ...request, nombre: newValue });
                  }
                }}
              />         
        </PanelDrawer>
    )
}